import React from 'react';
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    Divider,
    Paper,
    Grid,
} from '@mui/material';
import { CheckCircle, Cancel } from '@mui/icons-material';

const CompensationLeaveDetailsView = ({ dates = [], leaveInfo }) => {
    if (!dates || dates.length === 0) {
        return (
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                sx={{ p: 5, textAlign: 'center', color: 'gray' }}
            >
                <Typography variant="body2">No Comp Off Data Found</Typography>
            </Box>
        );
    }

    // Separate into taken and not taken
    const notTakenDates = dates.filter((d) => d.is_applied === 1); // Assuming 2 means already taken
    const takenDates = dates.filter((d) => d.is_applied === 2); // Assuming 1 means not taken

    return (
        <Box sx={{ p: 1 }}>
            {/* Summary */}
            <Paper
                elevation={2}
                sx={{
                    p: 2,
                    mb: 2,
                    borderRadius: 3,
                    display: 'flex',
                    justifyContent: 'space-between',
                    background: '#f9f9f9',
                    marginTop: '10px',
                }}
            >
                <Typography variant="subtitle2" fontWeight="bold" color="green">
                    Taken: {leaveInfo.leaveTaken}
                </Typography>
                <Typography variant="subtitle2" fontWeight="bold" color="red">
                    Not Taken: {leaveInfo.leavesBalance}
                </Typography>
                <Typography variant="subtitle2" fontWeight="bold">
                    Total: {leaveInfo.totaldays}
                </Typography>
            </Paper>

            {/* Row Layout */}
            <Grid container spacing={3}>
                {/* Taken Section */}
                <Grid item xs={12} md={6}>
                    <Paper
                        elevation={1}
                        sx={{
                            p: 2,
                            borderRadius: 3,
                            height: 400, // fixed height
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            color="green"
                            gutterBottom
                        >
                            Taken
                        </Typography>
                        <Box sx={{ flex: 1, overflowY: 'auto', pr: 1 }}>
                            {takenDates.length > 0 ? (
                                <List disablePadding dense>
                                    {takenDates.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <ListItem sx={{ py: 1 }}>
                                                <CheckCircle sx={{ color: 'green', mr: 1 }} />
                                                <ListItemText
                                                    primary={
                                                        <Typography variant="body1" fontWeight="bold">
                                                            {/* {new Date(item.date).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric',
                                                            })} */}
                                                            {item.date}
                                                        </Typography>
                                                    }
                                                />
                                            </ListItem>
                                            {index !== takenDates.length - 1 && <Divider />}
                                        </React.Fragment>
                                    ))}
                                </List>
                            ) : (
                                <Typography variant="body2" color="text.secondary">
                                    No taken records.
                                </Typography>
                            )}
                        </Box>
                    </Paper>
                </Grid>

                {/* Not Taken Section */}
                <Grid item xs={12} md={6}>
                    <Paper
                        elevation={1}
                        sx={{
                            p: 2,
                            borderRadius: 3,
                            height: 400, // fixed height
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            color="red"
                            gutterBottom
                        >
                            Not Taken
                        </Typography>
                        <Box sx={{ flex: 1, overflowY: 'auto', pr: 1 }}>
                            {notTakenDates.length > 0 ? (
                                <List disablePadding dense>
                                    {notTakenDates.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <ListItem sx={{ py: 1 }}>
                                                <Cancel sx={{ color: 'red', mr: 1 }} />
                                                <ListItemText
                                                    primary={
                                                        <Typography variant="body1" fontWeight="bold">
                                                            {/* {new Date(item.date).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric',
                                                            })} */}
                                                            {item.date}
                                                        </Typography>
                                                    }
                                                />
                                            </ListItem>
                                            {index !== notTakenDates.length - 1 && <Divider />}
                                        </React.Fragment>
                                    ))}
                                </List>
                            ) : (
                                <Typography variant="body2" color="text.secondary">
                                    No not taken records.
                                </Typography>
                            )}
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};

export default CompensationLeaveDetailsView;
